import _laxios from '../../_laxios';

module.exports = {
  namespaced: true,
  state: {
    packageData: [],
  },
  actions: {
    fetchPackageData({ commit, rootGetters }) {
      const { 'lang/id': langId } = rootGetters;
      const data = {
        params: { langId },
      };

      return _laxios.getPublicationPackageData
        .request(data)
        .then((payload) => {
          commit('setPackageData', { payload });
        })
        .catch((e) => {
          console.error('/cabinet/api/company/publicationPackage/packageData/', e.message);
        });
    },
  },
  mutations: {
    setPackageData(state, { payload }) {
      Object.assign(state, { packageData: payload });
    },
  },
  getters: {
    packageData({ packageData }) {
      return packageData;
    },
  },
};
